export default function Arrow(props) {
    return(
        <svg {...props} width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.2514 6.92923C6.64934 7.37853 7.35066 7.37853 7.7486 6.92923L13 1" stroke="#121212" strokeLinecap="round"/>
        </svg>
    )
}